<template>
  <div class="col-lg-2 col-12 py-2" >
    <div class="custom-control custom-switch">
      <input type="checkbox" name="check-button" class="custom-control-input" :checked="published" @input="updateValue"
             :id="`publishedCheckbox-${component_id}`"/>
      <label class="custom-control-label" :for="`publishedCheckbox-${component_id}`">{{ label }}</label>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      component_id: this.randomString(),
    }
  },
  name: "publishedCheckbox",
  props: ["published", 'label'],
  model: {
    prop: "published",
    event: "input",
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event.target.checked);
    },
    // generate random string
    randomString() {
      return Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15)
    },
  },
};
</script>